export const useRentalListingAgreementPartiesUtils = () => {
  const extractPendingReviewApprovals = (data) => {
    const landlords = data?.relationships?.rentalListingAgreementLandlords?.data || [];
    const landlordParties = landlords
      .map((landlord) => ({
        id: landlord.id,
        name: landlord?.attributes?.name || "Unknown",
        approval: landlord?.attributes?.riskScoringReviewApproval ?? false,
        role: "bailleur",
      }))
      .filter((landlord) => landlord.approval === false);

    const tenants = [];
    const rentalProperties = data?.relationships?.rentalListingAgreementProperties?.data || [];

    rentalProperties.forEach((rlap) => {
      const leases = rlap?.relationships?.property?.data?.relationships?.leaseAgreements?.data || [];
      leases.forEach((lease) => {
        const leaseTenants = lease?.relationships?.tenants?.data || [];
        leaseTenants.forEach((tenant) => {
          tenants.push({
            id: tenant.id,
            name: tenant?.attributes?.name || "Unknown",
            approval: tenant?.attributes?.riskScoringReviewApproval ?? false,
            role: "locataire",
          });
        });
      });
    });

    const tenantParties = tenants.filter((tenant) => tenant.approval === false);

    // Return one single flat array
    return [...landlordParties, ...tenantParties];
  };

  return {
    extractPendingReviewApprovals,
  };
};
